export interface FilterRequest{
	filterType: string;
	filter: string;
	filterKey: string;
}

export interface FilterBody {
  fieldFilters: FilterRequest[];
}
